@if (contractSignature !== undefined || contractSignature !== null) {
<div>
  <table id="pdfContract" #pdfContract style="width:100%; height:100% ">
    <tr>
      <td align="center" width="100%">
        <div class="contract-wrapper">
          <div class="page-content">
            <div class="image-position">
              <img style="width: 380px; height: 80px;" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png"
                alt="">
            </div>
            <div class="text-content">
              <h3 class="styling-the-title">TERMO DE ADESÃO AO PLANO DE MANUTENÇÃO PRÉ-PAGA FORD PROTECT Nº
                {{contractSignature.contractId}}</h3>
              <hr class="styling-the-hr">
            </div>
            <div class="col-12 top-element">
              <div class="header">
                <h5 class="header-title">DADOS DO VEÍCULO</h5>
              </div>
              <div class="info-box top-box-third">
                <div class="first-line-position">
                  <div class="first-line">
                    <i class="fas fa-solid fa-car-side icon-style"></i>
                  </div>
                  <div class="first-line">
                    <h5 class="bold-words">VEÍCULO:</h5>
                    <p>{{ contractSignature.vehicleLine }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 top-element">
              <div class="header">
                <h5 class="header-title">PLANO E VALOR</h5>
              </div>
              <div class="info-box top-box-fourth">
                <div class="first-line-position">
                  <div class="first-line">
                    <i class="fas fa-regular fa-dollar-sign icon-style"></i>
                  </div>
                  <div class="first-line">
                    <p>O plano contratado é o {{ contractSignature.maintenance.productName }},
                      cujo preço é {{contractSignature.maintenance.customerPrice | currency: 'R$:'}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 top-element contract-legal-block">
              <ol class="custom-list-text">
                <li class="li-text">
                  Pelo presente instrumento particular, o <span class="light-blue-box-text-bold">CONTRATANTE</span>
                  adere,
                  neste ato, ao Plano de Manutenção Pré-Paga
                  denominado “Ford Protect” (“Termo de Adesão”) idealizado pela <span
                    class="light-blue-box-text-bold">FORD
                    MOTOR COMPANY BRASIL LTDA.</span>, com sede na cidade de
                  São Paulo, Estado de São Paulo, na Avenida Doutor Cardoso de Melo, nº 1336, térreo, Vila Olímpia, CEP:
                  04548-004,
                  inscrita
                  no CNPJ/MF sob nº 03.470.727/0004-73 com uma de suas filiais estabelecida na Avenida Prefeito João
                  Vilallobo Quero,
                  nº 2237/2253, Sítio Pedra Rachada/Belval, na cidade de Barueri, Estado de São Paulo, CEP: 06422-122,
                  inscrita no CNPJ/MF sob nº 03.470.727/0012-83 (<span class="light-blue-box-text-bold">“FORD”</span>),
                  para proprietários de
                  veículos da marca <span class="light-blue-box-text-bold">FORD</span>.
                </li>
                <li class="li-text">
                  O Ford Protect tem por objeto a realização de revisões periódicas, levando em consideração
                  (i) a periodicidade recomendada; ou
                  (ii) a quilometragem do veículo (km rodados) ou,
                  (iii) se equipado, a indicação do Monitor Inteligente de Vida Útil do Óleo (IOLM),
                  sendo o que ocorrer primeiro, condições previstas no Manual do Proprietário.
                </li>
                <li class="li-text">
                  As revisões periódicas, ora contratadas por meio do presente instrumento, contemplam a troca de óleo
                  do
                  motor e a
                  substituição das seguintes peças: filtro de óleo do motor, filtro de combustível, elemento do filtro
                  de ar
                  do motor, elemento do
                  filtro de pólen da caixa de ventilação e velas de ignição. Sendo que, a substituição abrangerá apenas
                  os
                  itens
                  especificamente indicados no plano de manutenção de cada respectiva revisão
                </li>
                <li class="li-text">
                  As revisões incluem também a mão de obra para todas as inspeções e checagens previstas na tabela de
                  Manutenção e
                  Lubrificação do Manual do Proprietário, correspondente a cada uma das revisões.
                </li>
                <li class="li-text">
                  A presente adesão confere, gratuitamente, o benefício de 12 (doze) ou 24 (vinte e quatro) meses do
                  Programa Ford
                  Assistance (dependendo do plano contratado), respeitados os termos e condições estabelecidos no Manual
                  do
                  Proprietário
                  do Veículo. Uma vez que os veículos 0km já são cobertos com 12 (doze) meses de Programa Ford
                  Assistance,
                  a adesão ao Ford Protect aumentará o prazo de vigência do Programa Ford Assistance de acordo com o
                  plano
                  contratado.
                  Para veículos usados que estão fora do período de cobertura do Programa Ford Assistance original de 12
                  (doze) meses, o
                  prazo de cobertura será o pertinente ao plano contratado.
                </li>
                <li class="li-text">
                  Os planos disponíveis para adesão são:
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 1:</span>
                  inclui as 3 (três) primeiras revisões periódicas do Veículo e o benefício de 12 (doze) meses do
                  Programa
                  Ford Assistance;
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 2:</span>
                  inclui 3 (três) revisões periódicas do Veículo (2ª, 3ª e 4ª revisões) e o benefício de 12 (doze) meses
                  do Programa Ford Assistance;
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 3:</span>
                  inclui 3 (três) revisões periódicas do Veículo (3ª, 4ª e 5ª revisões) e o benefício de 12 (doze) meses
                  do Programa Ford Assistance;
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Plus:</span>
                  inclui as 5 (cinco) primeiras revisões periódicas do Veículo e o benefício de 24 (vinte e quatro)
                  meses do
                  Programa Ford Assistance
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Manutenção Premium (2 anos, 3 revisões ou 60.000
                    Km):</span>
                  inclui as 3 (três) primeiras revisões periódicas do Veículo e a substituição de peças de desgaste
                  natural;
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Manutenção Premium (2 anos, 4 revisões ou 80.000
                    Km):</span>
                  inclui as 4 (quatro) primeiras revisões periódicas do Veículo e a substituição de peças de desgaste
                  natural.
                </li>
                <li class="li-text">
                  Os <span class="light-blue-box-text-bold"> Planos de Manutenção Premium</span>, além de contemplar os
                  elementos correspondentes em cada respectiva revisão,
                  contemplam, também, a substituição de algumas peças de desgaste natural, a qualquer momento, durante o
                  período de
                  cobertura do plano, tempo ou quilômetros (km) rodados, o que ocorrer primeiro, restritos aos seguintes
                  componentes
                  (conforme modelo do Veículo, se equipado): Discos de Freio, Tambores de Freio Traseiros, Kit de Lona
                  de
                  Freio, Pastilhas
                  de Freio, Sapatas de Freio de Estacionamento, Disco de Embreagem da Transmissão Manual, Mangueira de
                  Retorno do
                  Reservatório de Expansão, Mangueira do Aquecedor, Mangueira Superior do Radiador, Mangueira de Retorno
                  do
                  Radiador,
                  Mangueira Inferior do Radiador, Mangueiras com Conectores, Mangueira de Retorno de Arrefecimento da
                  Turbina,
                  Mangueira de Desvio do Líquido de Arrefecimento para o Corpo de Borboletas, Correia de Acessórios,
                  Macpherson
                  Amortecedor da Suspensão Dianteira, Macpherson Amortecedor da Suspensão Traseira, Cartucho do
                  Amortecedor
                  Dianteiro e Cartucho do Amortecedor Traseiro. Nestes casos, a substituição dos itens de desgaste
                  natural
                  será determinada
                  pela tolerância de fábrica para a função da peça afetada, conforme análise técnica. Os itens cobertos
                  estão restritos aos
                  especificados neste contrato.
                </li>
                <li class="li-text">
                  <div class="text-atenttion">
                    <i class="fas fal fa-exclamation-triangle edit-danger"></i>
                    <p class="light-blue-box-text-bold">
                      Aplicam-se para todos os Planos: Caso haja necessidade de substituição ou reparo de peças além das
                      indicadas no Plano contratado, o Consultor técnico da Concessionária Ford comunicará, previamente,
                      o
                      CONTRATANTE, a fim de que este tenha ciência do que não está contemplado e autorize ou não a
                      substituição.
                    </p>
                  </div>
                </li>
                <li class="li-text">
                  <p class="light-blue-box-text-bold">
                    UTILIZAÇÃO DO PLANO DE MANUTENÇÃO PRÉ-PAGA FORD PROTECT
                  </p>
                </li>
                <li class="li-text">
                  Para a utilização, gozo e fruição do Plano contratado, o CONTRATANTE deverá escolher a Concessionária
                  Ford
                  de sua
                  preferência e agendar o atendimento. A lista de Concessionárias Ford poderá ser consultada no
                  site
                  <a href="http://www.ford.com.br">www.ford.com.br</a>, através do Centro de Atendimento Ford (“CAF”) no
                  telefone 0800-703-3673 ou
                  através do aplicativo
                  FordPass.
                </li>
                <li class="li-text">
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> deverá comparecer à Concessionária Ford
                  escolhida munido do Certificado de Registro e Licenciamento
                  do Veículo - CRLV e do Manual do Proprietário do Veículo. O tempo para a realização dos serviços no
                  veículo pela
                  Concessionária Ford escolhida poderá variar, conforme o fluxo de atendimentos em andamento na data
                  agendada pelo
                  <span class="light-blue-box-text-bold">CONTRATANTE</span>.
                </li>
                <li class="li-text">
                  O encaminhamento do Veículo à Concessionária Ford para realização das revisões periódicas dentro dos
                  intervalos
                  definidos é obrigação do <span class="light-blue-box-text-bold">CONTRATANTE</span> e essencial para a
                  operação correta e segura, bem como para assegurar o
                  melhor desempenho e durabilidade do Veículo.
                </li>
                <li class="li-text">
                </li>
                <li class="li-text">
                  O Plano está vinculado ao número do chassi do Veículo e dele não se dissociará em qualquer hipótese de
                  transferência do
                  Veículo pelo <span class="light-blue-box-text-bold">CONTRATANTE</span> a terceiros. Sendo assim, o
                  terceiro que adquirir
                  o Veículo do <span class="light-blue-box-text-bold">CONTRATANTE</span> poderá
                  efetuar os serviços remanescentes ainda não realizados pelo <span
                    class="light-blue-box-text-bold">CONTRATANTE</span>, desde que dentro do Período de Vigência do
                  presente Contrato e respeitados os intervalos de tempo e quilômetros (km) rodados, assim como fará jus
                  ao
                  benefício de 24
                  (vinte e quatro) ou 36 (trinta e seis) meses do Programa Ford Assistance (dependendo do plano
                  selecionado), conferido
                  gratuitamente.
                </li>
                <li class="li-text">
                  Em caso de roubo, furto ou perda total, que deverão ser comprovados mediante Boletim de Ocorrência
                  policial ou através de
                  documentação do seguro, a <span class="light-blue-box-text-bold">FORD</span> devolverá a quantia
                  referente
                  aos serviços contratados que não tenham sido realizados,
                  conforme procedimento e cálculo de saldo remanescente apurado, descrito na “APURAÇÃO DE SALDO
                  REMANESCENTE”
                </li>
                <li class="li-text">
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> que não realizar qualquer dos serviços
                  previstos no Plano dentro do Período de Vigência do presente
                  Contrato e de acordo com os intervalos de tempo e quilômetros (km) rodados estabelecidos neste
                  contrato
                  não poderá
                  realizar o serviço perdido fora do prazo estipulado. Os serviços posteriores, desde que abrangidos no
                  Plano contratado,
                  poderão ser realizados normalmente, resguardado o direito do Contratante de rescindir o Termo e ser
                  ressarcido do saldo
                  remanescente nos moldes previstos em “VIGÊNCIA E RESCISÃO”.
                </li>
                <li class="li-text">
                  Independente de qual Plano for contratado, a não realização de qualquer das revisões previstas no
                  Plano de
                  acordo com os
                  intervalos de tempo, quilômetros (km) rodados ou indicação do Monitor Inteligente de Vida Útil do Óleo
                  (se
                  equipado)
                  estabelecidos neste Termo e, da mesma forma, a não realização das revisões periódicas posteriores ao
                  término do Plano e
                  de acordo com os intervalos de tempo e quilômetros (km) rodados conforme Manual do Proprietário do
                  Veículo, poderão
                  ocasionar o cancelamento da garantia do Veículo, assim como as demais hipóteses de cancelamento
                  previstas
                  no Manual
                  do Proprietário.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  TOLERÂNCIA
                </li>
                <li class="li-text">
                  Como estabelecido no Manual do Proprietário, a tolerância máxima para execução das revisões
                  periódicas, é
                  de 1 (um) mês
                  ou 1.000 km para mais ou para menos, conforme abaixo:
                </li>
                <li class="li-text">
                  Para tempo de uso: a tolerância máxima é de 1 (um) mês para mais ou para menos do tempo definido. Ex.:
                  entre 11 (onze)
                  e 13 (treze) meses para a manutenção prevista para ocorrer aos 12 (doze) meses de uso;
                </li>
                <li class="li-text">
                  Para quilometragem: a tolerância máxima é de 1.000 km para mais ou para menos da quilometragem
                  definida.
                  Ex.: entre
                  9.000 e 11.000 km para a manutenção prevista para ocorrer aos 10.000 km rodados.
                </li>
                <li class="li-text">
                  A tolerância para Veículos Integrados com Monitor Inteligente de Vida Útil do óleo – IOLM: deve
                  ser consultada
                  no Manual do Proprietário a tolerância para execução de troca de cada item.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  RESPONSABILIDADE
                </li>
                <li class="li-text light-blue-box-text-bold">
                  A FORD não se responsabiliza e não reconhecerá qualquer custo e/ou despesa incorrida com
                  (i) serviços realizados pelo CONTRATANTE fora das Concessionárias Ford, cuja relação será
                  periodicamente atualizada e publicada no website da FORD ou disponível por meio do CAF; ou
                  (ii) por serviços realizados fora do estrito escopo previsto neste Termo. Em caso de dúvidas
                  sobre os serviços e produtos recomendados à manutenção do Veículo, o CONTRATANTE poderá consultar
                  seu Manual do Proprietário. Em caso de conflito entre o Manual do Proprietário e este Termo, o
                  CONTRATANTE está ciente que o Plano inclui apenas e tão somente os serviços descritos neste contrato e
                  que
                  por sua vez serão realizados conforme indicação de cada revisão.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  VALORES
                </li>
                <li class="li-text">
                  Nos valores do plano contratado estão inclusos os serviços e peças indicadas neste Termo, a serem
                  incorridas nos
                  intervalos de tempo e quilômetros (km) rodados também indicados neste contrato e conforme recomendado
                  pelo
                  Manual do
                  Proprietário, ou, para os itens de desgaste natural, conforme a necessidade indicada através do
                  diagnóstico, bem como o
                  valor do serviço de administração de bens e negócios de terceiros, conforme plano contratado.
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> declara,
                  neste ato, conhecer e aceitar que qualquer serviço ou peça adicional não contemplados neste Termo
                  deverão
                  ser pagos
                  separadamente, à Concessionária Ford, conforme condições negociadas no momento de sua realização.
                </li>
                <li class="li-text">
                  O valor a ser pago pelo <span class="light-blue-box-text-bold">CONTRATANTE</span> inclui todos os
                  custos e
                  despesas relacionados com impostos, taxas, tarifas ou
                  quaisquer outros que venham a incidir no âmbito deste Termo de Adesão.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  VIGÊNCIA E RESCISÃO
                </li>
                <li class="li-text">
                  Este Termo vigorará da data de emissão da nota fiscal referente a venda do Veículo, até a conclusão do
                  Plano de
                  Manutenção contratado, seguindo os seguintes prazos:
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 1:</span>
                  36 (trinta e seis) meses ou mediante a conclusão dos serviços contratados em atingindo a
                  quilometragem máxima programada de 30.000 km, ou 48.000 km para veículos equipados com o Monitor
                  Inteligente de Vida
                  Útil do Óleo, o que ocorrer primeiro ("Período de Vigência");
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 2:</span>
                  48 (quarenta e oito) meses ou mediante a conclusão dos serviços contratados em atingindo a
                  quilometragem máxima programada de 40.000 km, ou 64.000 km para veículos equipados com o Monitor
                  Inteligente de Vida
                  Útil do Óleo, o que ocorrer primeiro ("Período de Vigência");
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Basic 3:</span>
                  60 (sessenta) meses ou mediante a conclusão dos serviços contratados em atingindo a
                  quilometragem máxima programada de 50.000 km, ou 80.000 km para veículos equipados com o Monitor
                  Inteligente de Vida
                  Útil do Óleo, o que ocorrer primeiro ("Período de Vigência");
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Plus:</span>
                  60 (sessenta) meses ou mediante a conclusão dos serviços contratados em atingindo a quilometragem
                  máxima programada de 50.000 km, ou 80.000 km para veículos equipados com o Monitor Inteligente de Vida
                  Útil do Óleo, o
                  que ocorrer primeiro ("Período de Vigência");
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Manutenção Premium (2 anos, 3 revisões ou 60.000
                    Km):</span>
                  24 (vinte e quatro) meses ou mediante a conclusão dos serviços contratados em atingindo a
                  quilometragem
                  máxima programada de 60.000 km, o que ocorrer
                  primeiro ("Período de Vigência");
                </li>
                <li class="li-text">
                  <span class="light-blue-box-text-bold">Ford Protect Manutenção Premium (2 anos, 4 revisões ou 80.000
                    Km):</span>
                  24 (vinte e quatro) meses ou mediante a conclusão dos serviços contratados em atingindo a
                  quilometragem
                  máxima programada de 80.000 km, o que ocorrer
                  primeiro ("Período de Vigência").
                </li>
                <li class="li-text light-blue-box-text-bold">
                  Ressalta-se que o presente Termo apenas será considerado vigente e a sua respectiva ativação do Plano
                  de
                  Manutenção com o efetivo pagamento integral do preço estabelecido, seja por boleto ou confirmação do
                  cartão de
                  crédito. Em hipótese alguma haverá a prorrogação do prazo desta contratação.
                </li>
                <li class="li-text">
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> compreende que, para atender às demandas
                  do
                  Plano, a FORD fará investimentos de modo a manter a
                  qualidade de seus serviços e de acordo com o cronograma de revisões do Veículo. Caso o <span
                    class="light-blue-box-text-bold">CONTRATANTE</span> desista do
                  Plano, este poderá rescindir o presente Termo e terá o direito a ser ressarcido do saldo remanescente
                  (valor pago e não
                  usufruído), conforme cálculo abaixo descrito.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  APURAÇÃO DE SALDO REMANESCENTE
                </li>
                <li class="li-text">
                  Para apuração do saldo remanescente do Termo, o valor integral do Plano pago pelo <span
                    class="light-blue-box-text-bold">CONTRATANTE</span> será dividido
                  igualmente pelo número total de meses referentes ao plano de revisões periódicas do Veículo ou número
                  total de
                  quilômetros programados, dependendo do uso real do Veículo, meses considerada a data do pedido de
                  cancelamento ou
                  quilômetros (km) rodados, o que for maior.
                </li>
                <li class="li-text">
                  O valor a ser reembolsado será proporcional ao saldo remanescente do Plano, com base nos meses ou
                  quilômetros
                  programados faltantes, atualizado pelo IPCA e debitada uma multa administrativa no valor de R$ 50,00
                  (cinquenta reais).
                </li>
                <li class="li-text">
                  O pedido de cancelamento deverá ser comunicado à Concessionária Ford de sua preferência, através da
                  qual o
                  <span class="light-blue-box-text-bold">CONTRATANTE</span> deverá obter as orientações referentes ao
                  cancelamento.
                </li>
                <li class="li-text">
                  Em qualquer hipótese de desistência do Plano e rescisão do presente Termo, o benefício de 12 (doze) ou
                  24
                  (vinte e quatro)
                  meses do Programa Ford Assistance conferido gratuitamente será imediatamente cancelado, permanecendo
                  válidas as
                  disposições do Manual do Proprietário do Veículo quanto aos termos e condições do Ford Assistance,
                  inclusive o período de
                  validade.
                </li>
                <li class="li-text light-blue-box-text-bold">
                  OBRIGAÇÕES DO CONTRATANTE
                </li>
                <li class="li-text">
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> compromete-se a:
                  <ol class="custom-list-alphabet" type="a">
                    <li class="li-alphabet">
                      observar os direitos e obrigações que lhe são atribuídos pelo Plano escolhido,
                      bem como o Período de Vigência, levando, dentro deste período, seu Veículo para efetuar as
                      revisões em
                      uma
                      Concessionária Ford nos intervalos de tempo, km rodados ou indicação do Monitor Inteligente de
                      Vida
                      Útil do Óleo (se
                      equipado), conforme recomendado neste Contrato e no Manual do Proprietário;
                    </li>
                    <li class="li-alphabet">
                      além das revisões regulares, efetuar todas as verificações adicionais previstas no item Manutenção
                      do
                      Manual do
                      Proprietário do Veículo;
                    </li>
                    <li class="li-alphabet">
                      não exigir qualquer reembolso de custos e despesas incorridas em qualquer estabelecimento que não
                      a
                      Concessionária
                      Ford, ou ainda de serviços efetuados fora do escopo do presente Termo; e
                    </li>
                    <li class="li-alphabet">
                      manter seus dados pessoais para contato (nome completo, CPF, e-mail, telefones para contato,
                      endereço)
                      atualizados
                      ligando para o CAF, de modo a possibilitar futuros contatos da FORD estritamente relacionados a
                      este
                      Termo.
                    </li>
                  </ol>
                </li>
                <li class="li-text">
                  OBRIGAÇÕES DA FORD
                </li>
                <li class="li-text">
                  A <span class="light-blue-box-text-bold">FORD</span>, durante o Período de Vigência deste Contrato,
                  compromete-se a:
                  <ol class="custom-list-alphabet" type="a">
                    <li class="li-alphabet">
                      administrar, para o <span class="light-blue-box-text-bold">CONTRATANTE</span>, bens e serviços
                      relacionados ao Plano objeto deste Contrato;
                    </li>
                    <li class="li-alphabet">
                      assegurar a qualidade das peças aplicadas e dos serviços previstos neste Contrato a serem
                      efetuados no
                      Veículo pela
                      Concessionária Ford, nos termos do Plano e do Manual do Proprietário;
                    </li>
                    <li class="li-alphabet">
                      disponibilizar ao <span class="light-blue-box-text-bold">CONTRATANTE</span> canais de atendimento
                      para
                      dirimir suas dúvidas, sugestões e reclamações referentes
                      ao Plano;
                    </li>
                    <li class="li-alphabet">
                      atender, analisar e tomar as medidas que forem cabíveis relativas a toda e qualquer reclamação
                      referente a este
                      Contrato, bem como contatar a Concessionária Ford quando necessário; e
                    </li>
                    <li class="li-alphabet">
                      transferir apenas os dados pessoais do <span class="light-blue-box-text-bold">CONTRATANTE</span>
                      que
                      sejam estritamente necessários para a fruição do Plano
                      para as Concessionárias Ford (ou seja, nome completo, CPF, e-mail, telefone para contato, endereço
                      e
                      chassi do Veículo),
                      assegurando que esses serão deletados, tanto da base de dados da Ford, quanto da Concessionária
                      Ford,
                      após 10 (dez)
                      anos do término do Termo. Fica determinado que os dados pessoais poderão ser armazenados na Ford
                      Cloud, localizada
                      nos Estados Unidos, de forma segura e de acordo com as obrigações legais aplicáveis; e que após
                      esse
                      período, apenas o
                      chassi do veículo será utilizado para análises estatísticas.
                    </li>
                  </ol>
                </li>
                <li class="li-text light-blue-box-text-bold">
                  DA PROTEÇÃO DE DADOS
                </li>
                <li class="li-text">
                  Ao fornecer seus dados pessoais, você concorda e fornece o seu consentimento, conforme disposições da
                  Lei
                  13.709/18
                  para a coleta, tratamento e utilização de seus dados pela Ford, bem como com o compartilhamento destes
                  dados com
                  prestadores de serviço relacionados ao Ford Protect e transferência internacional para a matriz da
                  Ford
                  nos Estados Unidos
                  em razão de infraestrutura tecnológica.
                </li>
                <li class="li-text">
                  A Ford como controladora de seus dados pessoais, assegura ao <span
                    class="light-blue-box-text-bold">CONTRATANTE</span> que tratará os seus dados em absoluta
                  obediência a sua política de privacidade,
                  (<a class="a-edit-blue" href="https://www.ford.com.br/politica-de-privacidade/" target="_blank"
                    rel="noopener noreferrer">https://www.ford.com.br/politica-de-privacidade/</a>), bem como que poderá
                  exercer todos os seus direitos relacionados aos seus dados pessoais previstos em lei, através do
                  e-mail do
                  DPO da Ford (<a class="a-edit-blue" href="mailto:dpobrasi&#64;ford.com" target="_blank"
                    rel="noopener noreferrer">dpobrasi&#64;ford.com</a>).
                </li>
                <li class="li-text light-blue-box-text-bold">
                  DISPOSIÇÕES GERAIS
                </li>
                <li class="li-text">
                  Toda e qualquer comunicação deverá ser feita através do CAF. Os casos fortuitos e de força maior devem
                  ter
                  o tratamento determinado pelo artigo 393 do Código Civil Brasileiro.
                </li>
                <li class="li-text">
                  As partes elegem a Comarca do domicílio do <span class="light-blue-box-text-bold">CONTRATANTE</span>
                  como
                  competente para dirimir eventuais questões oriundas
                  deste Contrato. O Contratante poderá, a seu exclusivo critério, escolher ajuizar demandas perante o
                  foro
                  da Comarca de
                  São Paulo/SP.
                </li>
                <li class="li-text">
                  O <span class="light-blue-box-text-bold">CONTRATANTE</span> afirma e declara que o presente Termo será
                  assinado por
                  meio eletrônico, sendo considerada válida a referida assinatura.
                </li>
              </ol>
              <p class="custom-text-data">
                <span>{{city}},&ensp;</span>
                {{ contractSignature.salesDate | date:'dd' }} de
                {{ month }} de
                {{ contractSignature.salesDate | date:'yyyy' }}.
              </p>
            </div><!-- /.contract-legal-block -->
          </div><!-- /.page-content -->
        </div><!-- /.contract-wrapper -->
      </td>
    </tr>
  </table>
</div>
}